<template>
  <a-modal
    v-model:visible="visible"
    :title="null"
    ok-text="关闭"
    :footer="null"
    :mask-closable="false"
    :close-icon="null"
    :closable="false"
    :keyboard="false"
    :after-close="onAfterClose"
  >
    <!-- <div>应用名称：{{ appInfo?.name }}</div> -->
    <div class="bg-red2-50 flex items-center gap-2.5">
      <a-spin class="mt-1" />
      <!-- 文本内容 -->
      <div class="text-lg opacity-75">
        {{ message }}
      </div>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue';
import { useEmitterListener } from '@/hooks';
import { EventType } from '@/utils/emitter.utils';

const message = ref<string>('');

const visible = ref<boolean>(false);
defineExpose({
  open: async () => {
    visible.value = true;
    await nextTick();
  }
});

// 显示modal
useEmitterListener(
  EventType['modal:open-loading'],
  (data?: { message: string }) => {
    message.value = data?.message || '';
    console.log('打开loading', data?.message);

    visible.value = true;
  }
);

const afterClose = ref<() => void>();
useEmitterListener(
  EventType['modal:close-loading'],
  (data?: { afterClose?: () => void }) => {
    afterClose.value = data?.afterClose;
    visible.value = false;
  }
);

const onAfterClose = () => {
  afterClose.value?.();
  visible.value = false;
  message.value = '';
};
</script>

<style scoped></style>
